// extracted by mini-css-extract-plugin
export var optionGrid = "_6y-7";
export var optionList = "_6y-6";
export var questionsBlock = "_6y-9";
export var spacer = "_6y-5";
export var stepCenteredContent = "_6y-3";
export var stepInner = "_6y-0";
export var stepInnerFullWidth = "_6y-1";
export var stepInnerLockScroll = "_6y-2";
export var stepTransitionFrame = "_6y-4";
export var welcomeBlock = "_6y-8";